import React from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import SearchBox from "../../customer/components/SearchBox";
import Scroll from "../../shared/components/navigation/Scroll";
import Table from "../../shared/components/Table/Table";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import FloatingButton from "../../shared/components/UIElements/FloatingButton";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import { AuthContext } from "../../shared/context/auth-context";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { AlterationTableHeaders } from "../components/AlterationTableHeaders";
import { formatPhoneNumber } from "../../print/page/Print";
import { dateHandler } from "../../order/pages/Orders";

const Alterations = () => {
    const auth = useContext(AuthContext);
    const [loadedAlterations, setLoadedAlterations] = useState([]);
    const [searchfield, setSearchfield] = useState("");
    const [LoadArchive, setLoadArchive] = useState(false);
    const { isLoading, error, sendRequest, clearError } = useHttpClient();

    useEffect(() => {
        const fetchAlterations = async () => {
          let responseData;
          try {
            responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL+"/alterations",
              'GET',
              null,
              {Authorization: 'Bearer '+ auth.token}
            );
            setLoadedAlterations(responseData.alterations);
          } catch (err) { }
        };
        fetchAlterations();
      }, [auth.token, sendRequest]);

        const filteredAlterations = loadedAlterations.filter((alteration) => {
    return (
        alteration.orderNumber.includes(searchfield.toLowerCase()) ||
        alteration.customerName.toLowerCase().includes(searchfield.toLowerCase()) ||
        dateHandler(alteration.dueDate).includes(searchfield) ||
        String(alteration.phone).includes(searchfield.toLowerCase()) ||
        alteration.description.toLowerCase().includes(searchfield.toLowerCase())
    );
  }).map((alteration) => {
    return({
        ...alteration,
        numOfItems:  alteration.orders.length,
        dueDate: dateHandler(alteration.dueDate),
        phone: formatPhoneNumber(alteration.phone),
        description: (alteration.description).length > 22 ? ((alteration.description).slice(0, 20) + "...") : alteration.description,
        archive: alteration.archive === false ? 'false' : 'true' 
    })
  })
  .filter((alteration) =>{
    return(
      LoadArchive === 'true' ? alteration.archive ==='true' : alteration.archive === 'false' );
    })
    .reverse();

    const onSearchChange = (event) => {
        setSearchfield(event.target.value);
      };

    const onChangeHandler =(event) =>{
      setLoadArchive(event.target.value);
    }
  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && (
        <div className="center">
          <LoadingSpinner />
        </div>
      )}  

      <div className="show-order">
      <label>
      <select  onChange={onChangeHandler} className="pa2 bg-light-gray br3">
        <option value= {'false'} >Alterations</option>
        <option value= {'true'} >Archived Alterations</option>
      </select>
      </label>
    </div>

      <div className="tc">
        <div style={{ display: "inline-block" }}>
          <SearchBox searchChange={onSearchChange} />
        </div>
      </div>

      <Scroll>
        {!isLoading && filteredAlterations && (
          <Table headers={AlterationTableHeaders} content={filteredAlterations}   />
        )}
      </Scroll>
      <FloatingButton route={"/alterations/new"} />
    </React.Fragment>
  );
};

export default Alterations;
